/**
 * Mozaik page: the shared arcade boot (kit) with Mozaik's scenes (the level map opens first; &level=N
 * opens that level, as in every arcade game) and the video factory's caption band. Old links with
 * ?mode=quiz|daily|classic (before 2026-10-24 Mozaik had modes) simply land on the map.
 */
import { boot } from "@kit/boot";
import { game as mozaik } from "./index";
import { lang } from "./i18n";

const params = new URLSearchParams(location.search);

// tools/video-factory clip mode: a caption band above the game, reserved *before* Phaser boots so
// input bounds are right. The renderer updates its text (#clip-caption) for the payoff line.
const caption = params.get("caption");
if (caption) {
  const band = document.createElement("div");
  band.id = "clip-caption";
  band.textContent = caption;
  // Band scales with the viewport width (540 css px = phone; the renderer records at 1080 for crisp 9:16).
  const k = Math.min(2, Math.max(1, window.innerWidth / 540));
  const bandH = Math.round(84 * k);
  Object.assign(band.style, {
    position: "fixed",
    left: "0",
    right: "0",
    top: "0",
    boxSizing: "border-box",
    zIndex: "50",
    padding: `${Math.round(22 * k)}px ${Math.round(20 * k)}px`,
    background: "#12152b",
    color: "#fff",
    font: `800 ${Math.round(30 * k)}px system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif`,
    textAlign: "center",
    letterSpacing: "-0.01em",
    lineHeight: "1.2",
    minHeight: `${bandH}px`,
    height: "auto",
  } as Partial<CSSStyleDeclaration>);
  document.body.prepend(band);
  // Long captions wrap; the game area starts below the band's real height.
  const realH = Math.max(bandH, band.offsetHeight);
  const app = document.getElementById("app");
  if (app) {
    app.style.marginTop = `${realH}px`;
    app.style.height = `calc(100% - ${realH}px)`;
  }
}

boot({
  id: mozaik.meta.id,
  scenes: mozaik.scenes,
  instructions: lang === "en" ? "Pick a tile with the arrow keys; blast with Enter or Space." : "Ok tuşlarıyla kare seç; Enter veya Boşluk ile patlat.",
});
